import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ActionReasonModel} from "../../models/action-reason.model";
import {ActionReasonVisibilityEnum} from "../../enums/action-reason-visibility.enum";
import {ActionReasonEnum} from "../../enums/action-reason.enum";
import {ActionReasonEntityEnum} from "../../enums/action-reason-entity.enum";
import {ActionReasonsServiceService} from "../../services/action-reasons-service.service";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";

export class ActionReasonSelectComponent implements IController {

  selectedActionReason: ActionReasonModel;
  actionReasonTypes: ActionReasonEnum[];
  excludeIds: any;
  disable: any;
  actionReasonVisibilityTypes: ActionReasonVisibilityEnum[];
  pickupStatuses: TaskStatusType[];
  dropoffStatuses: TaskStatusType[];
  operationStatuses: TaskStatusType[];
  ngPlaceholder: any;
  fieldName?: string;
  noUnderline: any;
  actionReasonEntities: ActionReasonEntityEnum[];
  isRequired: boolean;
  onChange: Function;

  public actionReasons: any;
  public loading: boolean = false;

  constructor(private $mdSelect, private $log, private commonsAlertsService: CommonsAlertsService,
              private $actionReasons, private actionReasonsService: ActionReasonsServiceService) {
  }

  $onInit() {
    if (!this.excludeIds) {
      this.excludeIds = [];
    }

    if (!this.fieldName) {
      this.fieldName = 'actionReason'
    }

    if (this.selectedActionReason) {
      this._getActionReasons();
    }
  }

  onOpen() {
    return this._getActionReasons();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.selectedActionReason = undefined;
    this.onChange({selectedActionReason: this.selectedActionReason})
    this.$mdSelect.hide();
  }

  onSelect() {
    this.$mdSelect.hide();
    this.onChange({selectedActionReason: this.selectedActionReason})
  }

  private _getActionReasons() {
    this.loading = true;
    return this.actionReasonsService.getActionReasons(
      this.actionReasonVisibilityTypes,
      this.actionReasonEntities,
      this.actionReasonTypes,
      this.pickupStatuses,
      this.dropoffStatuses,
      this.operationStatuses
    )
      .then((actionReasons) => {
        let actionReasonsCopy = angular.copy(actionReasons);
        if (this.excludeIds.length) {
          actionReasonsCopy = _.filter(actionReasons, (b) => {
            return _.indexOf(this.excludeIds, b.id) === -1;
          });
        }

        this.actionReasons = actionReasonsCopy;
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to get service areas @branchesMultiSelect@onOpen', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .component('actionReasonSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedActionReason: '<',
      actionReasonTypes: '<',
      actionReasonEntities: '<',
      actionReasonVisibilityTypes: '<',
      pickupStatuses: '<?',
      dropoffStatuses: '<?',
      operationStatuses: '<?',
      excludeIds: '<?',
      disable: '<',
      isRequired: '<?',
      ngPlaceholder: '@?',
      fieldName: '<?',
      noUnderline: '@?',
      onChange: '&'
    },
    template: require('./action-reason-select.html').default,
    controller: ActionReasonSelectComponent
  });

